<template>
  <v-container class="footer" fluid>
    <div class="footer-tnc">
      <div class="copyright font-size-40">
        {{ $t('footer.allrights') }}
      </div>
      <div class="policy font-size-40">
        <a @click="getPrivacyPolicy">
          {{ $t('footer.privacy') }}
        </a>
        |
        <a @click="getTNC">
          {{ $t('footer.tnc') }}
        </a>
      </div>
    </div>

    <v-dialog v-model="tncDialogShown" scrollable>
      <v-card light v-if="tnc">
        <v-card-title class="tnc-title title-font">{{ tncDialogShownTnc ? tnc.title : tnc.privacy_title }}</v-card-title>

        <v-card-text v-html="tncDialogShownTnc ? tnc.content : tnc.privacy_content" class="text-left"></v-card-text>

        <v-card-actions class="tnc-actions">
          <v-spacer></v-spacer>

          <v-btn text
                 class="tnc-action title-font"
                 color="rgb(142, 118, 91)"
                 @click="tncDialogShown = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";

export default {
  name: 'Footer',
  setup(props, {root}) {
    const tnc = ref(null);
    const tncDialogShown = ref(false);
    const tncDialogShownTnc = ref(false);
    const getPrivacyPolicy = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'sasv/tnc/',
      })

      tnc.value = response.body;
      tncDialogShown.value = true;
      tncDialogShownTnc.value = false;
    }
    const getTNC = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'sasv/tnc/',
      })

      tnc.value = response.body;
      tncDialogShown.value = true;
      tncDialogShownTnc.value = true;
    }

    return {

      tnc,
      tncDialogShown,
      tncDialogShownTnc,
      getPrivacyPolicy,
      getTNC,
    }
  }
}
</script>

<style lang="less">
.footer {
  background-color: #1a1f28;
  padding: 3rem 0 6rem 0 !important;;

  a {
    color: #616161 !important;
  }
}

.footer-container {
  padding: 0rem 1rem !important;
  max-width: none;

  @media only screen and (min-width: 700px) {
    padding: 0rem 2rem;
  }
  @media only screen and (min-width: 1200px) {
    padding: 0rem 14rem;
  }
  @media only screen and (min-width: 1700px) {
    padding: 0rem 20rem;
  }
}

.footer-tnc {
  color: #616161;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;

  .copyright {
    display: flex;
    flex-wrap: wrap;
    flex-grow: 1;
    padding: 10px 0;
  }

  .policy {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
    padding: 10px 0;

    a {
      margin: 0 5px;
    }
  }

  @media only screen and (max-width: 960px) {
    flex-direction: column-reverse;
    .policy {
      justify-content: flex-start;
    }
  }
}
</style>
